import Link from '@jetbrains/ring-ui/dist/link/link'
import { useTracking } from 'react-tracking'

import { useLogout } from '../../../hooks/useLogout'
import { Error } from '../Error/Error'
import { authorize } from '../../../services/authorization'
import { useLocationStateSaver } from '../../../hooks/urlStateParam'

export const FetchingUserError = () => {
	const { trackEvent } = useTracking()
	const getSerializedState = useLocationStateSaver()

	const [isLogoutInProgress, handleLoginAgainClick] = useLogout(trackEvent, undefined, () =>
		authorize(getSerializedState()),
	)

	return (
		<Error
			title={'❌ Oops, something went wrong'}
			content={
				<div>
					Please try to{' '}
					<Link disabled={isLogoutInProgress} onClick={handleLoginAgainClick}>
						login again
					</Link>
				</div>
			}
		/>
	)
}
